import { gql } from "types";

export const MARK_NOTIFICATION_AS_READ = gql(/* GraphQL */ `
  mutation MarkNotificationAsRead($input: MarkNotificationReadInput!) {
    markNotificationAsRead(input: $input) {
      id
      readAt
    }
  }
`);

export const MARK_ALL_NOTIFICATIONS_AS_READ = gql(/* GraphQL */ `
  mutation MarkAllNotificationsAsRead($input: MarkAllNotificationsReadInput) {
    markAllNotificationsAsRead(input: $input)
  }
`);

export const DELETE_ALL_NOTIFICATIONS = gql(/* GraphQL */ `
  mutation DeleteAllNotifications($type: String) {
    deleteAllNotifications(type: $type)
  }
`);

export const MARK_NOTIFICATIONS_AS_SEEN = gql(/* GraphQL */ `
  mutation MarkNotificationsAsSeen($input: MarkNotificationsSeenInput!) {
    markNotificationsAsSeen(input: $input)
  }
`);
